import { render, staticRenderFns } from "./ThemeAndGradeType.vue?vue&type=template&id=54fac711&scoped=true"
import script from "./ThemeAndGradeType.vue?vue&type=script&lang=js"
export * from "./ThemeAndGradeType.vue?vue&type=script&lang=js"
import style0 from "./ThemeAndGradeType.vue?vue&type=style&index=0&id=54fac711&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fac711",
  null
  
)

export default component.exports